<template>
  <div class="music" @click="switchMusic">
    <img src="~@/assets/imgs/public/music-on.png" v-show="on" class="rotate">
    <img src="~@/assets/imgs/public/music-off.png" v-show="!on">
  </div>
</template>

<script>
export default {
  name: 'music',

  data () {
    return {
      on: true
    }
  },

  methods: {
    switchMusic () {
      this.$bus.toggleMusic()
      this.on = !this.on
    }
  }
}
</script>

<style lang="scss">
.music {
  position: fixed;
  padding: .2rem;
  width: 8.5vw;
  z-index: 200;
  top: 0;
  right: 0;
  img {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/music.vue